import { Dispatch, SetStateAction, useState } from 'react';
import { ConfirmationDialogProps } from '.';

type ReturnValue<T> = {
  dialogRelevantValue: T | undefined;
  setDialogRelevantValue: Dispatch<SetStateAction<T | undefined>>;
  dialogProps: Pick<ConfirmationDialogProps, 'open' | 'onClose'>;
};

export const useDialog = <T>(): ReturnValue<T> => {
  const [dialogRelevantValue, setDialogRelevantValue] = useState<T>();

  return {
    dialogRelevantValue,
    setDialogRelevantValue,
    dialogProps: {
      open: Boolean(dialogRelevantValue),
      onClose: () => setDialogRelevantValue(undefined)
    }
  };
};
